<template>
  <PageTemplate :class="componentClass" :title="metaTitle" :noContainer="true">
    <v-sheet color="grey" id="sobre">
      <v-container>
        <v-row class="align-center py-15 flex-column-reverse flex-lg-row">
          <v-col cols="12" md="6" lg="5">
            <TitleWidget :align="'left'">{{ item.title }}</TitleWidget>
            <div class="my-6" v-html="item.text"></div>
            <!-- Missão -->
            <!-- <v-divider class="my-10"></v-divider>
            <v-tabs background-color="transparent" v-model="tab">
              <v-tabs-slider color="primary"></v-tabs-slider>
              <v-tab v-for="(item, key) in mission" :key="key">
                {{ item.title }}
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item v-for="(item, key) in mission" :key="key">
                <v-card flat>
                  <v-card-text>
                    <div v-html="item.text"></div>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items> -->
          </v-col>
          <v-col cols="12" md="6" lg="6" offset-lg="1">
            <v-img class="about-img" :src="this.files + item.img"></v-img>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>

    <!-- Equipe -->
    <v-container class="py-10">
      <TitleWidget class="mb-3">Equipe</TitleWidget>
      <p class="text-center">
        Profissionais qualificados para melhor lhe atender
      </p>
      <v-row class="mt-10 justify-center">
        <v-col cols="6" md="3" v-for="(item, key) in team" :key="key">
          <TeamCard :item="item"></TeamCard>
        </v-col>
      </v-row>
    </v-container>
  </PageTemplate>
</template>

<script>
import PageTemplate from "../components/templates/PageTemplate.vue";
import TeamCard from "../components/cards/TeamCard.vue";
import TitleWidget from "../components/widgets/TitleWidget.vue";
/**
 * $route.meta = {
 *   mod: string; // Chave do módulo.
 *   ?title: string | (component) => string; // Título da página.
 *   ?params: Record<string, string> | (component) => Record<string, string>; // Parametros da requisição de dados
 * }
 */
export default {
  data: () => ({
    loading: true,
    tab: null,
  }),
  computed: {
    metaTitle() {
      const metaTitle = this.$route.meta.title;

      if (!metaTitle) {
        return this.$route.name;
      }

      if (typeof metaTitle === "function") {
        return metaTitle(this);
      } else {
        return metaTitle;
      }
    },
    mod() {
      return {
        about: this.$route.meta.about,
        team: this.$route.meta.team,
        mission: this.$route.meta.mission,
      };
    },
    item() {
      return this.$rest(this.mod.about).item;
    },
    // mission() {
    //   return this.$rest(this.mod.mission).list;
    // },
    team() {
      return this.$rest(this.mod.team).list;
    },
    parsedTitle() {
      return this.item.title?.replace(/\\"/g, '"');
    },
    parsedImg() {
      const path = this.item.img;

      return path ? this.files + path + "?resize=1&w=600" : null;
    },

    componentClass() {
      return "about-custom-view";
    },
  },
  methods: {
    getData() {
      this.$rest(this.mod.about)
        .get({
          save: (state, data) => (state.item = data),
        })
        .catch(() => this.$router.replace({ path: "/erro404" }))
        .finally(() => (this.loading = false));
    },
  },
  watch: {
    mod() {
      this.getData();
    },
  },
  created() {
    this.getData();
    this.$rest(this.mod.team).get();
    this.$rest(this.mod.mission).get();
  },
  components: {
    PageTemplate,
    TeamCard,
    TitleWidget,
  },
};
</script>

<style lang="scss">
.about-custom-view {
  text-align: justify;

  .about-custom-view-img {
    float: left;

    img {
      width: 100%;
      max-width: 540px;
      display: flex;
      margin-right: 16px;
      margin-bottom: 40px;
    }
  }
}

@media screen and (max-width: 960px) {
  .about-custom-view-img {
    float: none !important;
    display: flex;
    justify-content: center;

    img {
      margin-right: 0px !important;
      margin-bottom: 0px !important;
    }
  }
}
</style>
